import React from "react";

const giftingData = [
  {
    title: "Premium Gift Sets",
    description: "Bed Linen, Towels, Cushions",
  },
  {
    title: "Occasion-based Gifting",
    description: "Festivals, Weddings, Housewarmings",
  },
  {
    title: "Personalized Packaging",
    description: "Luxury wraps, monograms",
  },
];

const GiftingCard = ({ title, description }) => {
  return (
    <div className="card h-100 border-0 rounded-4 shadow-sm gifting-card">
      <div className="card-body text-center p-4">
        <h5 className="card-title fw-bold mb-3">{title}</h5>
        <p className="card-text text-muted">{description}</p>
      </div>
    </div>
  );
};

const GiftingSection = () => {
  return (
    <section className="py-5">
      <div className="container">
        <h2 className="text-center mb-5 fw-bold fs-1">Gifting Options</h2>
        <div className="row g-4">
          {giftingData.map((item, index) => (
            <div key={index} className="col-12 col-md-4">
              <GiftingCard title={item.title} description={item.description} />
            </div>
          ))}
        </div>
      </div>

      <style jsx>{`
        .gifting-card {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          cursor: pointer;
        }
        .gifting-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
        }
        .card-title {
          font-family: 'Playfair Display', serif;
          color: #333;
        }
        .card-text {
          font-size: 0.95rem;
          line-height: 1.5;
        }
      `}</style>
    </section>
  );
};

export default GiftingSection;
